module.exports = __webpack_public_path__ + "img/img2.56635867.jpg";